<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    disable: reconcileForm.invalid,
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <form class="reconcile-container" [formGroup]="reconcileForm">
    <ion-row>
      <ion-col size="12">
        <app-form-select
          formControlName="routes"
          [label]="CONSTS.ROUTE_LABEL"
          [placeholder]="CONSTS.ROUTE_LABEL_PLACEHOLDER"
          [options]="routes"
          [customClass]="'scan-type-dropdown report-select'"
        ></app-form-select>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>
